import * as React from 'react';
export const GLSvg = React.forwardRef(function GLSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.994 2A1.998 1.998 0 0 0 0 3.998V8h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 2a2 2 0 0 1 2 2v4h-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4H0V4a2 2 0 0 1 2-2h12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M3 8a2 2 0 1 0 4 0h9v4.002c0 1.1-.893 1.998-1.994 1.998H1.994C.894 14 0 13.106 0 12.002V8h3Z',
        opacity: 0.9,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M7 8H3a2 2 0 1 1 4 0Z',
      }),
    ),
  );
});
GLSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GL = {
  category: 'flag',
  colorable: false,
  name: 'GL',
  svg: GLSvg,
};
